// extracted by mini-css-extract-plugin
export var gap = "StandardGrid-module--gap--6075a";
export var grid = "StandardGrid-module--grid--d4325";
export var padded = "StandardGrid-module--padded--cb159";
export var paddedTlr = "StandardGrid-module--paddedTlr--e55e2";